//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'signUpSuccess'
}
